export default __webpack_public_path__ + "static/banner_connpass_20231122-4c4130d1a1e7204f8ef46a54198b3279.png";